/**
 * User roles — additive permissions on top of baseline access.
 *
 * All authenticated users have baseline access (view/manage invoices,
 * documents, parties, cost centers) without any role.
 * Roles only grant elevated permissions.
 *
 * - ADMIN: Full account management capabilities
 * - SECURITY_ADMIN: User, API key, webhook, and account settings management
 * - ACCOUNTANT: Invoice approval/export, party management, document reprocessing
 * - APPROVER: Invoice approval
 * - RULES_MANAGER: AI Rules management and viewing
 * - CODE_LISTS_MANAGER: cost centres, jobs, org structure and products
 * - SYSTEM_BILLING_ADMIN: Cross-account billing management, has access to AMS
 * - SYSTEM_SUPPORT_ADMIN: Cross-account user impersonation, has access to AMS
 */
export const UserRole = {
  ADMIN: 'ADMIN',
  SECURITY_ADMIN: 'SECURITY_ADMIN',
  ACCOUNTANT: 'ACCOUNTANT',
  APPROVER: 'APPROVER',
  RULES_MANAGER: 'RULES_MANAGER',
  CODE_LISTS_MANAGER: 'CODE_LISTS_MANAGER',
  SYSTEM_BILLING_ADMIN: 'SYSTEM_BILLING_ADMIN',
  SYSTEM_SUPPORT_ADMIN: 'SYSTEM_SUPPORT_ADMIN'
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];
